import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { useCreateProjectPermission } from '@atlassian/jira-nav-item-service/src/services/create-project-permisson/index.tsx';
import { testIdConcat } from '@atlassian/jira-navigation-apps-common/src/utils/test-id.tsx';
import { projectsDirectoryRoute } from '@atlassian/jira-router-routes-directories-routes/src/projectsDirectoryRoute.tsx';
import { useSwitchModals } from '@atlassian/jira-switch-modals-controller/src/index.tsx';
import { useIsAnonymous } from '@atlassian/jira-tenant-context-controller/src/components/is-anonymous/index.tsx';
import { MODAL_ID } from '../../../../common/constants.tsx';
import { MenuItem } from '../../../../common/ui/menu/item/index.tsx';
import messages from './messages.tsx';
import type { FooterProps } from './types.tsx';

export const Footer = ({ testIdPrefix }: FooterProps) => {
	const { formatMessage } = useIntl();
	const isAnonymous = useIsAnonymous();
	const [, { on: openProjectCreateDrawer }] = useSwitchModals(MODAL_ID.PROJECT_CREATE);
	const [{ canCreateProject }] = useCreateProjectPermission();
	const testId = testIdConcat(testIdPrefix, 'items');

	return (
		<span data-testid={testId}>
			<MenuItem
				analytics={{
					actionSubjectId: 'projectsNavigationMenuItem',
					menuItemId: 'viewAll',
					menuItemType: 'action',
					position: 0,
				}}
				href="/jira/projects"
				testId={testIdConcat(testId, 'item-view-all')}
				to={projectsDirectoryRoute}
			>
				{formatMessage(messages.viewAll)}
			</MenuItem>
			{!isAnonymous && canCreateProject && (
				<MenuItem
					analytics={{
						actionSubjectId: 'projectsNavigationMenuItem',
						menuItemId: 'create',
						menuItemType: 'action',
						position: 1,
					}}
					onClick={openProjectCreateDrawer}
					testId={testIdConcat(testId, 'item-create')}
				>
					{formatMessage(messages.createProject)}
				</MenuItem>
			)}
		</span>
	);
};
